import React from "react";
import IframePage from "./IframePage";
import "../../../css/BoletinOficial/resoluciones-individuales.css";

const ResolucionesIndividuales = () => (
  <IframePage
    title="RESOLUCIONES INDIVIDUALES"
    description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
    iframeUrl="https://ciudaddeoliva.gov.ar/boletin-oficial/resoluciones.aspx"
    classPrefix="resoluciones"
  />
);

export default ResolucionesIndividuales;
